import { render, staticRenderFns } from "./shopsOrder.vue?vue&type=template&id=33c02ea6&scoped=true"
import script from "./shopsOrder.vue?vue&type=script&lang=js"
export * from "./shopsOrder.vue?vue&type=script&lang=js"
import style0 from "./shopsOrder.vue?vue&type=style&index=0&id=33c02ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c02ea6",
  null
  
)

export default component.exports